// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__24gE9","buttons":"PendingPaymentAlert_buttons__3ebuQ"};